var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedinOld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm0 0",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.785 5.625c-.55 0-.91.36-.91.836 0 .465.348.836.887.836h.011c.563 0 .91-.371.91-.836-.011-.477-.347-.836-.898-.836zM6.97 7.953h1.61v4.84h-1.61zm5.554-.11c-.867 0-1.449.813-1.449.813v-.703H9.47v4.84h1.605V10.09c0-.145.012-.29.055-.39.117-.29.379-.59.824-.59.582 0 .813.445.813 1.093v2.59h1.609V10.02c0-1.489-.793-2.176-1.852-2.176zm0 0",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinOld);
export default ForwardRef;